import { MSG_ERRO_SERVIDOR } from "../../shared/constantes/mensagens";

const INITIAL_STATE = {
  esperandoRespostaSolicitacao: false,
  mensagem: "",
  codigo: "",
  gRecaptchaResponse: "",
  exibirCodigo: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //ERROS
    case "AUTENTICIDADE_ERRO_CATCHA_OFF_LINE":
    case "AUTENTICIDADE_ERRO_CATCHA_NAO_RESOLVIDO":
    case "AUTENTICIDADE_ERRO_FORMULARIO_INCOMPLETO":
      return {
        ...state,
        esperandoRespostaSolicitacao: false,
        mensagem: action.payload,
      };

    //ATUALIZACAO DE INFORMACAO
    case "AUTENTICIDADE_CODIGO_ATUALIZADO":
      return {
        ...state,
        esperandoRespostaSolicitacao: false,
        codigo: action.payload,
        mensagem: "",
      };
    case "AUTENTICIDADE_RECAPTCHA_RESPONSE_ATUALIZADO":
      return {
        ...state,
        esperandoRespostaSolicitacao: false,
        gRecaptchaResponse: action.payload,
      };
    case "RESET_RECAPTCHA_RESPONSE":
      return {
        ...state,
        gRecaptchaResponse: "",
      };

    //ACOES DE IMPRESSAO
    case "AUTENTICIDADE_IMPRESSAO_SOLICITADA":
      return { ...state, esperandoRespostaSolicitacao: true };
    case "AUTENTICIDADE_IMPRESSAO_RECEBIDA":
      return { ...state, esperandoRespostaSolicitacao: false };
    case "AUTENTICIDADE_ERRO_IMPRESSAO_RECEBIDO":
      return {
        ...state,
        esperandoRespostaSolicitacao: false,
        mensagem: action.payload ? action.payload : MSG_ERRO_SERVIDOR,
      };

    default:
      return state;
  }
};
